<template>
  <div class="date-container" :class="{error:error}">
    <Datepicker
      class="input-date"
      locale="ja"
      week-start="0"
      v-model="date"
      :format="dateFormat"
      :enableTimePicker="false"
      :textInput="isTextInput"
      :disabled="isDisabled"
      :clearable="isClearable"
      :minDate="minDate"
      :maxDate="maxDate"
      :day-class="getDayClass"
      autoApply
    />
    <p class="input-error" v-if="error">{{ error }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'

import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
// import { useConfigStore } from '@/store/config'
export default defineComponent({
  setup(props, context) {
    // const configStore = useConfigStore()

    onMounted(async ()=>{
      // 初期値をサーバーサイドのシステム日付にする（24.1.1 大塚）
      // こうしておいても特に困らないはず・・・
      // await configStore.getSysDatetime()
      // if(configStore.sysDatetime){
      //   context.emit('update:modelValue', configStore.sysDatetime.toLocaleDateString('ja-JP', {year: 'numeric', month: '2-digit', day: 'numeric'}));
      // }
    })

    const date = computed({
      get() {
        return props.modelValue
      },
      set(val) {
        if (val && typeof val === 'object') {
          context.emit('update:modelValue', (val as Date).toLocaleDateString('ja-JP', {year: 'numeric', month: '2-digit', day: 'numeric'}));
        } else {
          context.emit('update:modelValue', val);
        }
      }
    })
    const dateFormat = ref('yyyy/MM/dd')

    const isClearable = computed(() => {
      if(typeof props.clearable === 'undefined' || typeof props.clearable !== 'boolean'){
        // props未指定時
        return true
      }
      return props.clearable
    })

    const isTextInput = computed(() => {
      if(typeof props.textInput === 'undefined' || typeof props.textInput !== 'boolean'){
        // props未指定時
        return true
      }
      return props.textInput
    })

    const isDisabled = computed(() => {
      if(typeof props.disabled === 'undefined' || typeof props.disabled !== 'boolean'){
        // props未指定時
        return false
      }
      return props.disabled
    })

    const getDayClass = (date: Date) => {
      const weekDay = date.getDay()
      if (weekDay == 6) {
        // 土曜日の場合、classに"saturday"を追加
        return 'saturday'
      } else if (weekDay == 0) {
        // 日曜日の場合、classに"sunday"を追加
        return 'sunday'
      }
      return ''
    }

    return {
      date,
      dateFormat,
      isClearable,
      isTextInput,
      isDisabled,
      getDayClass
    }
  },
  props: ['modelValue', 'clearable', 'error', 'minDate', 'maxDate', 'textInput', 'disabled'],
  emits:['update:modelValue'],
  components: {
    Datepicker
  }
})
</script>

<style>
/* scopedの中には書かない */
.saturday {
  color: #0000ff;
}

.sunday {
  color: #ff0000;
}
</style>
